import React, { useEffect, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import FormGroup from 'components/form/FormGroup';
import debounce from 'debounce-promise';

import {
  VStack,
  SimpleGrid,
  Box,
  useToast,
  Stack,
  HStack,
  Flex,
  Button,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

import { yupResolver } from '@hookform/resolvers/yup';
import FormInput from 'components/form/FormInput';
import FormTextArea from 'components/form/FormTextArea';
import { Controller } from 'react-hook-form';
import { formatDate } from '../../utils/formataData';
import DatePicker from '../../components/form/FormDatePicker';
import { Select } from '../../components/form/Select';
import BoxContent from '../../components/BoxContent';
import AsyncSelect from '../../components/form/AsyncSelect';
import api from '../../services/api';
import { useTravaPm } from '../../contexts/travapm';

import TituloPagina from '../../components/TituloPagina';
import { useAuth } from '../../contexts/auth';

interface IEntrada {
  tipo_trava: number;
  data_inicio: Date;
  data_fim: Date;
  observacao: string;
}
interface ITipotrava {
  nome: string;
}

interface IUnidade {
  uni_nome: string;
  uni_sigla: string;
}

interface ITravaPm {
  id_trava_pm: number;
  pm_codigo: number;
  tipo_trava: number;
  observacao: string;
  tipoTrava: ITipotrava;
  unidade: IUnidade;
  data_inicio: Date;
  data_fim: Date;
  criado_por?: string;
  criado_em?: string;
  atualizadoEm?: string;
  atualizadoPor?: string;
}
type OptionType = { label: string; value: string };

const schema = Yup.object().shape({
  tipo_trava: Yup.number().required('Campo Obrigatório'),
  data_inicio: Yup.date().required('Campo Obrigatório'),
  data_fim: Yup.date().required('Campo Obrigatório'),
});

const ShowTravaPm: React.FC = () => {
  const { user } = useAuth();
  const toast = useToast();
  const history = useHistory();
  const [travaPm, setTravaPm] = useState<ITravaPm>();
  const { idTravaPm } = useTravaPm();

  const { errors, handleSubmit, register, control } = useForm<IEntrada>({
    resolver: yupResolver(schema),
    defaultValues: {
      tipo_trava: travaPm?.tipo_trava,
      data_inicio: travaPm?.data_inicio,
      data_fim: travaPm?.data_fim,
      observacao: travaPm?.observacao,
    },
  });
  const [pecaSelecionada, setPecaSelecionada] = useState<
    OptionType | undefined
  >(undefined);
  const [fornecedoresDisponiveis, setFornecedoresDisponiveis] = useState<any>(
    [],
  );

  const handleSair = (): void => {
    history.push('/listartravapm');
  };

  const promiseItens = useCallback(async (inputValue: string): Promise<
    OptionType[] | undefined
  > => {
    try {
      const response = await api.get(`unidades/async?query=${inputValue}`);

      const data = response.data || [];

      const responseFormated = data.unidades.map((item: any) => {
        return {
          value: item.uni_codigo,
          label: `${item.uni_sigla} - (Lob: ${item.uni_lob})`,
        };
      });

      return responseFormated;
    } catch (error) {
      return undefined;
    }
  }, []);

  const delayedQuery = useCallback(
    debounce((query: string) => promiseItens(query), 500),
    [promiseItens],
  );
  const [erroItem, setErroItem] = useState(false);

  const handleAdicionarTravaPm = async (data: any): Promise<any> => {
    if (pecaSelecionada) {
      setErroItem(false);
      const dados = {
        ...data,
        uni_codigo: pecaSelecionada.value,
        criado_por: user.matricula,
      };
      try {
        const inserirTipoTrava = await api.post(`/travapm`, dados);
        toast({
          title: 'Sucesso.',
          description: 'Cadastro de tipo de trava inserido com sucesso',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
        history.push('/listartravapm');
      } catch (error) {
        toast({
          title: 'Erro',
          description: 'Erro ao inserir o trava Pm',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
      }
    } else {
      setErroItem(true);
    }
  };

  useEffect(() => {
    const fornecedores = async (): Promise<any> => {
      const listaFornecedores = await api.get('/tipotrava');
      const optionsFornecedores = listaFornecedores.data.items.map(
        (fornecedor: any) => {
          return {
            value: fornecedor.id_tipo_trava,
            label: fornecedor.nome,
          };
        },
      );
      setFornecedoresDisponiveis(optionsFornecedores);
    };
    const loadCounts = async (): Promise<void> => {
      try {
        const categoriaGet = await api.get(`/travapm/${idTravaPm}`);
        setTravaPm(categoriaGet.data);
      } catch (error) {
        console.log('Ocorreu um erro');
      }
    };
    loadCounts();

    fornecedores();
  }, [user]);

  return (
    <>
      {travaPm && (
        <Stack>
          <TituloPagina title="Trava de OPM" />
          <BoxContent>
            <Box>
              <VStack spacing="4">
                <SimpleGrid minChildWidth="300px" spacing={['2', '4']} w="100%">
                  <FormGroup name="Pm">
                    <FormInput
                      name="teste"
                      disabled
                      defaultValue={travaPm?.pm_codigo}
                      register={register}
                    />
                  </FormGroup>
                  <FormGroup name="Tipo Trava">
                    <FormInput
                      name="trava"
                      disabled
                      defaultValue={travaPm?.tipoTrava.nome}
                      register={register}
                    />
                  </FormGroup>

                  <FormGroup name="Data Inicial">
                    <FormInput
                      name="inicio"
                      disabled
                      defaultValue={formatDate(
                        String(travaPm.data_inicio),
                        'dd/MM/yyyy',
                      )}
                      register={register}
                    />
                  </FormGroup>
                  <FormGroup name="Data Final">
                    <FormInput
                      name="fim"
                      disabled
                      defaultValue={formatDate(
                        String(travaPm.data_fim),
                        'dd/MM/yyyy',
                      )}
                      register={register}
                    />
                  </FormGroup>
                  <FormGroup name="Observacao">
                    <FormInput
                      name="observacao"
                      disabled
                      defaultValue={travaPm?.observacao}
                      register={register}
                    />
                  </FormGroup>
                  <FormGroup name="Registro Cadastrado Por">
                    <FormInput
                      name="cadastro"
                      disabled
                      defaultValue={travaPm?.criado_por}
                      register={register}
                    />
                  </FormGroup>
                  <FormGroup name="Registro Criado Em">
                    <FormInput
                      name="cadastro"
                      disabled
                      defaultValue={formatDate(
                        String(travaPm.criado_em),
                        'dd/MM/yyyy',
                      )}
                      register={register}
                    />
                  </FormGroup>
                </SimpleGrid>
                <Flex mt="8" justify="flex-end">
                  <HStack spacing="4">
                    <Button onClick={handleSair} as="a" colorScheme="red">
                      Voltar
                    </Button>
                  </HStack>
                </Flex>
              </VStack>
            </Box>
          </BoxContent>
        </Stack>
      )}
    </>
  );
};

export default ShowTravaPm;
